"use strict";

document.addEventListener("DOMContentLoaded", function () {
  const productPage = document.querySelector(".product-page");
  if (!productPage) return;

  // Get data from script tag
  const dataScript = document.getElementById("product-page-data");
  if (!dataScript) return;

  const config = JSON.parse(dataScript.textContent);
  const { sectionId, productData, currentVariant, moneyFormat, translations } =
    config;

  // Initialize accordion
  if (window.initAccordionSection) {
    window.initAccordionSection(sectionId);
  }

  const productForm = document.querySelector(".product-form");
  if (!productForm) return;

  let currentSlideIndex = 0;
  let activeThumbnailIndex = 0;

  // Mobile Slider
  const slider = document.getElementById("media-slider");
  const slides = document.querySelectorAll(".media-wrapper");

  let isDragging = false;
  let startPos = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;
  let currentIndex = 0;
  const isMobile = window.innerWidth < 1000;
  let dragThreshold = 30;

  // VIDEO
  const videos = document.querySelectorAll(".product-page .main-video");
  const videoContainers = document.querySelectorAll(".video-container");
  const overlayPlays = document.querySelectorAll(".overlay-play");
  const bullets = document.querySelectorAll(".slider-bullet");

  document
    .querySelectorAll(".media-wrapper img, .media-wrapper video")
    .forEach((el) => {
      el.addEventListener("dragstart", (e) => e.preventDefault());
    });

  function initializeVideos() {
    videos.forEach((video) => {
      video.currentTime = 0.1;
      video.pause();
      video.loop = true;
      video.muted = true;
      video.pauseInline = true;
    });
  }

  function setupDesktopVideoControls() {
    if (isMobile) return;
    videoContainers.forEach((container) => {
      const video = container.querySelector("video");
      const overlay = container.querySelector(".overlay-play");
      container.addEventListener("click", (e) => {
        if (
          e.target === container ||
          e.target === overlay ||
          e.target === video
        ) {
          e.preventDefault();
          if (video.paused) {
            video.play();
            container.classList.add("play");
          } else {
            video.pause();
            container.classList.remove("play");
          }
        }
      });
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting && !video.paused) {
              video.pause();
              container.classList.remove("play");
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(container);
    });
  }

  let observer;
  function setupMobileVideoBehavior() {
    if (!isMobile) {
      observer?.disconnect();
      return;
    }
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target.querySelector("video");
          if (!video) return;
          if (entry.isIntersecting) {
            video.play().catch(() => {
              const container = video.closest(".video-container");
              if (container) container.classList.add("autoplay-failed");
            });
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.7, rootMargin: "0px" }
    );
    slides.forEach((slide) => observer.observe(slide));
    document
      .querySelectorAll(".video-container.autoplay-failed")
      .forEach((container) => {
        container.addEventListener("click", function () {
          const video = this.querySelector("video");
          if (video.paused) {
            video.play();
            this.classList.remove("autoplay-failed");
          }
        });
      });
  }

  function handleVideoPlayback(index) {
    if (!isMobile) return;
    videos.forEach((video, i) => {
      const container = video.closest(".video-container");
      if (i === index) {
        video.play().catch(() => {});
        container.classList.add("play");
      } else {
        video.pause();
        container.classList.remove("play");
      }
    });
  }

  function updateBullets() {
    bullets.forEach((bullet, index) => {
      bullet.classList.toggle("active", index === currentIndex);
    });
  }

  function touchStart(e) {
    if (!isMobile) return;
    startPos = getPositionX(e);
    slider.style.transition = "none";
    isDragging = false;
  }

  function touchMove(e) {
    if (!isMobile) return;
    const currentPosition = getPositionX(e);
    const movedDistance = Math.abs(currentPosition - startPos);
    if (movedDistance > dragThreshold && !isDragging) {
      isDragging = true;
    }
    if (isDragging) {
      currentTranslate = prevTranslate + currentPosition - startPos;
      slider.style.transform = `translateX(${currentTranslate}px)`;
    }
  }

  function touchEnd(e) {
    if (!isMobile || !isDragging) {
      if (!isDragging) {
        const clickX = getPositionX(e);
        const slideWidth = slider.offsetWidth;
        const slideCenter = slideWidth / 2;
        const clickPosition = clickX - slider.getBoundingClientRect().left;
        if (clickPosition < slideCenter && currentIndex > 0) {
          currentIndex--;
        } else if (
          clickPosition >= slideCenter &&
          currentIndex < slides.length - 1
        ) {
          currentIndex++;
        }
      }
      prevTranslate = -currentIndex * slider.offsetWidth;
      slider.style.transition = "transform 0.3s ease";
      slider.style.transform = `translateX(${prevTranslate}px)`;
      updateBullets();
      handleVideoPlayback(currentIndex);
      isDragging = false;
      return;
    }
    isDragging = false;
    const movedBy = currentTranslate - prevTranslate;
    if (movedBy < -50 && currentIndex < slides.length - 1) currentIndex++;
    if (movedBy > 50 && currentIndex > 0) currentIndex--;
    prevTranslate = -currentIndex * slider.offsetWidth;
    slider.style.transition = "transform 0.3s ease";
    slider.style.transform = `translateX(${prevTranslate}px)`;
    updateBullets();
    handleVideoPlayback(currentIndex);
  }

  function getPositionX(e) {
    return e.type.includes("touch") ? e.touches[0].clientX : e.clientX;
  }

  function initSlider() {
    if (isMobile && slider) {
      prevTranslate = -currentIndex * slider.offsetWidth;
      slider.style.transform = `translateX(${prevTranslate}px)`;
      slider.addEventListener("touchstart", touchStart, { passive: true });
      slider.addEventListener("touchmove", touchMove, { passive: true });
      slider.addEventListener("touchend", touchEnd);
      bullets.forEach((bullet, index) => {
        bullet.addEventListener("click", () => {
          currentIndex = index;
          prevTranslate = -currentIndex * slider.offsetWidth;
          slider.style.transition = "transform 0.3s ease";
          slider.style.transform = `translateX(${prevTranslate}px)`;
          updateBullets();
          handleVideoPlayback(currentIndex);
        });
      });
    }
  }

  initializeVideos();
  initSlider();
  if (isMobile) {
    setupMobileVideoBehavior();
  } else {
    setupDesktopVideoControls();
  }

  // VARIANT HANDLING
  const radios = document.querySelectorAll(
    '.variant-selector input[type="radio"]'
  );

  // Auto-select first available if only 1 option
  if (productData.options.length === 1) {
    const firstAvailable = productData.variants.find((v) => v.available);
    if (firstAvailable) {
      updateVariant(firstAvailable);
      document.querySelectorAll(".variant-option input").forEach((input) => {
        const isAvailable = productData.variants.some(
          (v) => v.available && v.options[0] === input.value
        );
        !isAvailable
          ? input.classList.add("disabled")
          : input.classList.remove("disabled");

        if (firstAvailable.options[0] === input.value) input.checked = true;
      });
    }
  }

  radios.forEach((radio) => {
    radio.addEventListener("change", function () {
      const selectedOptions = getSelectedOptions();
      const selectedVariant = findVariantByOptions(selectedOptions);
      if (selectedVariant) updateVariant(selectedVariant);
      updateOptionAvailability(selectedOptions);
      // Update add-to-cart button state after main product variant change
      if (typeof updateAddToCartButtonState === "function") {
        updateAddToCartButtonState();
      }
    });
  });

  function updateOptionAvailability(selectedOptions) {
    productData.options.forEach((optionName, optionIndex) => {
      const groupInputs = document.querySelectorAll(
        `.variant-option:nth-child(${optionIndex + 1}) input`
      );
      groupInputs.forEach((input) => {
        const isPossible = productData.variants.some((variant) => {
          if (!variant.available) return false;
          return variant.options.every((opt, idx) => {
            if (idx === optionIndex) return opt === input.value;
            return !selectedOptions[idx] || selectedOptions[idx] === opt;
          });
        });
        !isPossible
          ? input.classList.add("disabled")
          : input.classList.remove("disabled");
      });
    });
  }

  function getSelectedOptions() {
    const selectedOptions = [];
    document.querySelectorAll(".variant-option").forEach((group) => {
      const checked = group.querySelector('input[type="radio"]:checked');
      const labels = group.querySelectorAll(".option-value");
      labels.forEach((label) => label.classList.remove("selected"));
      if (checked) {
        selectedOptions.push(checked.value);
        const checkedLabel = group.querySelector(`label[for="${checked.id}"]`);
        if (checkedLabel) checkedLabel.classList.add("selected");
      } else {
        selectedOptions.push(null);
      }
    });
    return selectedOptions;
  }

  function findVariantByOptions(options) {
    return productData.variants.find((variant) => {
      return variant.options.every(
        (opt, idx) => !options[idx] || options[idx] === opt
      );
    });
  }

  function updateVariant(variant) {
    window.history.replaceState(null, null, `?variant=${variant.id}`);
    productForm.querySelector('[name="id"]').value = variant.id;
    updatePrices(variant);
    updateAvailability(variant);

    // Fix image handling
    const firstImageEl = document.querySelector(".variant-dynamic-image");
    if (firstImageEl) {
      if (variant.featured_media) {
        firstImageEl.src = variant.featured_media.preview_image.src;
        firstImageEl.alt = variant.featured_media.alt || "";
      } else if (productData.featured_media) {
        firstImageEl.src = productData.featured_media.preview_image.src;
        firstImageEl.alt = productData.featured_media.alt || "";
      }
    }
  }

  function updatePrices(variant) {
    const currentPrice = document.querySelector(".current-price");
    const comparePrice = document.querySelector(".compare-price");
    const savings = document.querySelector(".savings");
    if (!currentPrice || !comparePrice) return;
    currentPrice.textContent = Shopify.formatMoney(variant.price, moneyFormat);
    if (variant.compare_at_price > variant.price) {
      comparePrice.textContent = Shopify.formatMoney(
        variant.compare_at_price,
        moneyFormat
      );
      savings.textContent = `${Shopify.formatMoney(
        variant.compare_at_price - variant.price,
        moneyFormat
      )} ${translations.saved}`;
      comparePrice.style.display = "inline";
      savings.style.display = "inline";
    } else {
      comparePrice.style.display = "none";
      savings.style.display = "none";
    }
  }

  function updateAvailability(variant) {
    const addToCartBtn = document.querySelector(
      ".product-page .add-to-cart-btn"
    );
    const buyNowBtn = document.querySelector(".buy-now-btn");
    const buyNowWarn = document.querySelector(".buy-now-warn");
    const quantitySelector = document.querySelector(".quantity-selector");
    const selectedValueElements = document.querySelectorAll(".selected-value");
    if (variant && variant.options) {
      variant.options.forEach((opt, idx) => {
        if (selectedValueElements[idx]) {
          selectedValueElements[idx].textContent = opt;
        }
      });
    }
    if (variant.available) {
      buyNowBtn.classList.remove("hidden");
      buyNowBtn.style.display = "block";
      buyNowWarn.style.display = "none";
      quantitySelector.style.display = "flex";
      addToCartBtn.textContent = translations.addToCart;
      // Check upsell availability before enabling
      updateAddToCartButtonState();
    } else {
      buyNowBtn.style.display = "none";
      buyNowWarn.style.display = "block";
      quantitySelector.style.display = "none";
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = translations.soldOut;
    }
  }

  function checkUrlVariant() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get("variant");
    if (variantId) {
      const variant = productData.variants.find((v) => v.id == variantId);
      if (variant) updateVariant(variant);
    } else {
      updateVariant(currentVariant);
    }
    updateOptionAvailability(getSelectedOptions());
  }

  // Quantity controls
  const minusBtn = document.querySelector(".quantity-btn.minus");
  const plusBtn = document.querySelector(".quantity-btn.plus");
  if (minusBtn) {
    minusBtn.addEventListener("click", () => {
      const qty = document.querySelector(".quantity-input");
      if (parseInt(qty.value) > 1) qty.value = parseInt(qty.value) - 1;
    });
  }
  if (plusBtn) {
    plusBtn.addEventListener("click", () => {
      const qty = document.querySelector(".quantity-input");
      qty.value = parseInt(qty.value) + 1;
    });
  }

  // Form submission
  productForm.addEventListener("submit", async function (e) {
    e.preventDefault();
    const formData = new FormData(productForm);
    const submitBtn = productForm.querySelector('[type="submit"]');
    const originalText = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = translations.adding;

    try {
      // Get selected upsell products
      const upsellProducts = [];
      document
        .querySelectorAll('input[name="upsell-products[]"]:checked')
        .forEach((checkbox) => {
          upsellProducts.push({
            id: checkbox.value,
            quantity: 1,
          });
        });

      // Create items array with main product and upsell products
      const items = [
        { id: formData.get("id"), quantity: formData.get("quantity") },
        ...upsellProducts,
      ];

      const cartUrl = window.routes.cart_add_url + ".js";
      const response = await fetch(cartUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });

      const data = await response.json();
      if (response.ok) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          action: "add",
          variant: data,
          formData: Object.fromEntries(formData),
          product: productData,
        });
      } else {
        throw new Error(data.description || "Failed to add to cart");
      }
    } catch (error) {
      console.error("Error:", error);
      publish(PUB_SUB_EVENTS.cartError, {
        error: error.message,
        context: "add-to-cart",
        productId: productData.id,
      });
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = originalText;
    }
  });

  // Buy Now button handling
  const buyNowBtn = document.querySelector(".buy-now-btn");
  if (buyNowBtn) {
    buyNowBtn.addEventListener("click", function () {
      // Create a hidden form for checkout
      const checkoutForm = document.createElement("form");
      checkoutForm.method = "POST";
      checkoutForm.action = "/cart/add";

      // Add main product
      const mainProductInput = document.createElement("input");
      mainProductInput.type = "hidden";
      mainProductInput.name = "items[0][id]";
      mainProductInput.value = productForm.querySelector('[name="id"]').value;
      checkoutForm.appendChild(mainProductInput);

      const mainProductQty = document.createElement("input");
      mainProductQty.type = "hidden";
      mainProductQty.name = "items[0][quantity]";
      mainProductQty.value =
        productForm.querySelector('[name="quantity"]').value;
      checkoutForm.appendChild(mainProductQty);

      // Add upsell products
      const upsellCheckboxes = document.querySelectorAll(
        'input[name="upsell-products[]"]:checked'
      );
      upsellCheckboxes.forEach((checkbox, index) => {
        const upsellIdInput = document.createElement("input");
        upsellIdInput.type = "hidden";
        upsellIdInput.name = `items[${index + 1}][id]`;
        upsellIdInput.value = checkbox.value;
        checkoutForm.appendChild(upsellIdInput);

        const upsellQtyInput = document.createElement("input");
        upsellQtyInput.type = "hidden";
        upsellQtyInput.name = `items[${index + 1}][quantity]`;
        upsellQtyInput.value = 1;
        checkoutForm.appendChild(upsellQtyInput);
      });

      // Add redirect to checkout
      const returnToInput = document.createElement("input");
      returnToInput.type = "hidden";
      returnToInput.name = "return_to";
      returnToInput.value = "/checkout";
      checkoutForm.appendChild(returnToInput);

      document.body.appendChild(checkoutForm);
      checkoutForm.submit();
    });
  }

  // Sticky section
  const sticky = document.querySelector(".product-info-sticky");
  const TOP_MARGIN = 70;
  const REC_HEIGHT = 600;

  const updateStickySection = () => {
    if (sticky) {
      const stickyHeight = sticky.getBoundingClientRect().height;
      sticky.style.top = `-${stickyHeight + REC_HEIGHT - window.innerHeight}px`;
    }
  };

  if (!isMobile && sticky) updateStickySection();

  window.addEventListener(
    "resize",
    debounce(() => {
      const newIsMobile = window.innerWidth < 1000;
      if (newIsMobile !== isMobile) location.reload();
      if (!isMobile) updateStickySection();
    }),
    150
  );

  checkUrlVariant();

  const productSection = document.querySelector(".product-section");
  const variantSelector = document.querySelector(".group-observer");

  if (variantSelector) {
    let announceObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (
            entry &&
            !entry.isIntersecting &&
            entry.boundingClientRect.top < 0
          ) {
            productSection.classList.add("show");
          } else {
            productSection.classList.remove("show");
          }
        });
      },
      { threshold: 0.5 }
    );

    announceObserver.observe(variantSelector);
  }

  // SIZE CHART
  const sizeBtn = document.querySelector("[data-open-table]");
  const sizePopup = document.querySelector(".size-chart-popup");
  const sizePopupContent = sizePopup
    ? sizePopup.querySelector(".size-chart-content")
    : null;
  const sizeClosePopup = sizePopup
    ? sizePopup.querySelector(".size-chart-close")
    : null;
  let isOpening = true;
  const toggleSizeChart = () => {
    if (isOpening) {
      document.body.style.overflow = "hidden";
      sizePopup.classList.add("open");
      isOpening = false;
    } else {
      document.body.style.overflow = "";
      sizePopup.classList.remove("open");
      isOpening = true;
    }
  };
  if (sizeBtn && sizePopup) {
    sizeBtn.addEventListener("click", toggleSizeChart);
    sizePopup.addEventListener("click", (e) => {
      if (
        !sizePopupContent.contains(e.target) &&
        sizePopupContent !== e.target &&
        !isOpening
      ) {
        toggleSizeChart();
      }
    });
  }
  if (sizeClosePopup) {
    sizeClosePopup.addEventListener("click", toggleSizeChart);
  }
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !isOpening) toggleSizeChart();
  });

  // UPSELL VARIANT SELECTION
  function initUpsellVariants() {
    const upsellForms = document.querySelectorAll(".product-upsell-form");

    upsellForms.forEach((form) => {
      const expandBtn = form.querySelector(".upsell-variant-expand");
      const variantWrapper = form.querySelector(
        ".upsell-variant-selector-wrapper"
      );
      const wrapper = form.querySelector(".upsell-wrapper");
      const dataScript = form.querySelector(".upsell-product-data");

      if (!expandBtn || !variantWrapper || !dataScript) return;

      const upsellData = JSON.parse(dataScript.textContent);
      const {
        product: upsellProduct,
        currentVariant: upsellCurrentVariant,
        moneyFormat: upsellMoneyFormat,
      } = upsellData;
      const checkbox = form.querySelector(".upsell-checkbox");
      const currentPriceEl = form.querySelector(".upsell-current-price");
      const comparePriceEl = form.querySelector(".upsell-compare-price");
      const selectedValueEls = form.querySelectorAll(".upsell-selected-value");

      // Function to toggle variant selector visibility
      const toggleVariantSelector = (show) => {
        if (show) {
          wrapper.classList.add("expanded");
          variantWrapper.style.display = "block";
        } else {
          wrapper.classList.remove("expanded");
          variantWrapper.style.display = "none";
        }
      };

      // Toggle accordion with arrow button
      expandBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isExpanded = wrapper.classList.contains("expanded");
        toggleVariantSelector(!isExpanded);
      });

      // Show/hide variant selector based on checkbox state
      if (checkbox) {
        checkbox.addEventListener("change", function () {
          if (this.checked) {
            toggleVariantSelector(true);
          } else {
            toggleVariantSelector(false);
          }
        });
      }

      // Prevent label click from toggling checkbox when clicking expand button area
      const label = form.querySelector(".upsell-label");
      if (label && expandBtn) {
        label.addEventListener("click", (e) => {
          // Check if click is on or near the expand button
          const expandBtnRect = expandBtn.getBoundingClientRect();
          const clickX = e.clientX;
          const clickY = e.clientY;

          if (
            clickX >= expandBtnRect.left - 10 &&
            clickX <= expandBtnRect.right + 10 &&
            clickY >= expandBtnRect.top - 10 &&
            clickY <= expandBtnRect.bottom + 10
          ) {
            e.preventDefault();
            e.stopPropagation();
          }
        });
      }

      // Handle variant radio changes - make all options clickable
      const variantRadios = form.querySelectorAll(".upsell-variant-radio");
      const variantErrorEl = form.querySelector(".upsell-variant-error");

      variantRadios.forEach((radio) => {
        // Allow clicks even on disabled options
        radio.addEventListener("change", function () {
          // Always allow the change to go through
          const selectedOptions = getUpsellSelectedOptions(form);
          const selectedVariant = findUpsellVariantByOptions(
            upsellProduct,
            selectedOptions
          );

          if (selectedVariant) {
            updateUpsellVariant(
              form,
              selectedVariant,
              upsellProduct,
              upsellMoneyFormat,
              checkbox,
              currentPriceEl,
              comparePriceEl,
              selectedValueEls
            );
          }

          // Update availability after selection
          updateUpsellOptionAvailability(form, upsellProduct, selectedOptions);

          // Check if selected variant is out of stock
          checkUpsellVariantAvailability(form, selectedVariant, variantErrorEl);

          // Update add-to-cart button state
          updateAddToCartButtonState();
        });

        // Make disabled labels clickable - remove pointer-events restriction
        const label = form.querySelector(`label[for="${radio.id}"]`);
        if (label) {
          // Ensure disabled labels can still trigger clicks
          label.style.pointerEvents = "auto";
        }
      });

      // Initialize availability and selected values
      const initialOptions = getUpsellSelectedOptions(form);
      updateUpsellOptionAvailability(form, upsellProduct, initialOptions);

      // Check initial variant availability
      const initialVariant = findUpsellVariantByOptions(
        upsellProduct,
        initialOptions
      );
      checkUpsellVariantAvailability(form, initialVariant, variantErrorEl);

      // Set initial selected values display
      if (
        upsellCurrentVariant &&
        upsellCurrentVariant.options &&
        selectedValueEls
      ) {
        upsellCurrentVariant.options.forEach((opt, idx) => {
          if (selectedValueEls[idx]) {
            selectedValueEls[idx].textContent = opt;
          }
        });
      }

      // Also check when checkbox is checked/unchecked
      if (checkbox) {
        checkbox.addEventListener("change", function () {
          updateAddToCartButtonState();
        });
      }
    });

    // Initial check of add-to-cart button state
    updateAddToCartButtonState();
  }

  function getUpsellSelectedOptions(form) {
    const selectedOptions = [];
    form.querySelectorAll(".upsell-variant-option").forEach((group) => {
      const checked = group.querySelector(".upsell-variant-radio:checked");
      const labels = group.querySelectorAll(".upsell-option-value");
      labels.forEach((label) => label.classList.remove("selected"));
      if (checked) {
        selectedOptions.push(checked.value);
        const checkedLabel = group.querySelector(`label[for="${checked.id}"]`);
        if (checkedLabel) checkedLabel.classList.add("selected");
      } else {
        selectedOptions.push(null);
      }
    });
    return selectedOptions;
  }

  function findUpsellVariantByOptions(product, options) {
    return product.variants.find((variant) => {
      return variant.options.every(
        (opt, idx) => !options[idx] || options[idx] === opt
      );
    });
  }

  function updateUpsellVariant(
    form,
    variant,
    product,
    moneyFormat,
    checkbox,
    currentPriceEl,
    comparePriceEl,
    selectedValueEls
  ) {
    // Update checkbox value
    if (checkbox) {
      checkbox.value = variant.id;
    }

    // Update prices
    if (currentPriceEl) {
      currentPriceEl.textContent = Shopify.formatMoney(
        variant.price,
        moneyFormat
      );
    }

    if (comparePriceEl) {
      if (variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = Shopify.formatMoney(
          variant.compare_at_price,
          moneyFormat
        );
        comparePriceEl.style.display = "block";
      } else {
        comparePriceEl.style.display = "none";
      }
    }

    // Update selected values display
    if (variant && variant.options && selectedValueEls) {
      variant.options.forEach((opt, idx) => {
        if (selectedValueEls[idx]) {
          selectedValueEls[idx].textContent = opt;
        }
      });
    }
  }

  function updateUpsellOptionAvailability(form, product, selectedOptions) {
    product.options.forEach((optionName, optionIndex) => {
      const groupInputs = form.querySelectorAll(
        `.upsell-variant-option:nth-child(${
          optionIndex + 1
        }) .upsell-variant-radio`
      );
      groupInputs.forEach((input) => {
        const label = form.querySelector(`label[for="${input.id}"]`);
        const isPossible = product.variants.some((variant) => {
          if (!variant.available) return false;
          return variant.options.every((opt, idx) => {
            if (idx === optionIndex) return opt === input.value;
            return !selectedOptions[idx] || selectedOptions[idx] === opt;
          });
        });

        if (label) {
          if (!isPossible) {
            label.classList.add("disabled");
            input.classList.add("disabled");
          } else {
            label.classList.remove("disabled");
            input.classList.remove("disabled");
          }
        }
      });
    });
  }

  function checkUpsellVariantAvailability(form, variant, errorEl) {
    if (!errorEl) return;

    if (!variant) {
      // No variant found - hide error for now
      errorEl.style.display = "none";
      return;
    }

    if (!variant.available) {
      // Variant is out of stock
      const variantName = variant.options
        ? variant.options.join(" / ")
        : "Selected variant";
      errorEl.textContent = `${variantName} is out of stock`;
      errorEl.style.display = "block";
      errorEl.style.color = "#f44336";
      errorEl.style.fontSize = "var(--fluid-12-14)";
      errorEl.style.marginTop = "1rem";
    } else {
      // Variant is available
      errorEl.style.display = "none";
    }
  }

  function updateAddToCartButtonState() {
    const addToCartBtn = document.querySelector(
      ".product-page .add-to-cart-btn"
    );
    if (!addToCartBtn) return;

    // Check all checked upsell products
    const checkedUpsells = document.querySelectorAll(
      'input[name="upsell-products[]"]:checked'
    );
    const outOfStockUpsells = [];

    checkedUpsells.forEach((checkbox) => {
      const form = checkbox.closest(".product-upsell-form");
      if (!form) return;

      const dataScript = form.querySelector(".upsell-product-data");
      if (!dataScript) return;

      try {
        const upsellData = JSON.parse(dataScript.textContent);
        const selectedOptions = getUpsellSelectedOptions(form);
        const selectedVariant = findUpsellVariantByOptions(
          upsellData.product,
          selectedOptions
        );

        if (selectedVariant && !selectedVariant.available) {
          // Get product title from label
          const label = form.querySelector(".upsell-label h4");
          const productTitle = label
            ? label.textContent.trim()
            : upsellData.product.title || "Upsell";

          // Get variant name
          const variantName = selectedVariant.options
            ? selectedVariant.options.join(" / ")
            : selectedVariant.title || "selected variant";

          outOfStockUpsells.push({
            product: productTitle,
            variant: variantName,
          });
        }
      } catch (e) {
        console.error("Error checking upsell availability:", e);
      }
    });

    // Disable add-to-cart if any checked upsell has out of stock variant
    if (outOfStockUpsells.length > 0) {
      addToCartBtn.disabled = true;

      // Create informative message - keep it concise
      let message = "";
      if (outOfStockUpsells.length === 1) {
        const item = outOfStockUpsells[0];
        message = `${item.variant} sold out`;
      } else {
        // Multiple out of stock items - show count
        message = `${outOfStockUpsells.length} variants sold out`;
      }

      addToCartBtn.textContent = message;
      addToCartBtn.style.opacity = "0.5";
      addToCartBtn.style.cursor = "not-allowed";
    } else {
      // Check main product availability
      const mainVariantId = document.querySelector(
        '.product-form [name="id"]'
      )?.value;
      const productData = JSON.parse(
        document.getElementById("product-page-data")?.textContent || "{}"
      );
      const mainVariant = productData.productData?.variants?.find(
        (v) => v.id == mainVariantId
      );

      if (mainVariant && mainVariant.available) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent =
          productData.translations?.addToCart || "Add to cart";
        addToCartBtn.style.opacity = "1";
        addToCartBtn.style.cursor = "pointer";
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent =
          productData.translations?.soldOut || "Sold out";
        addToCartBtn.style.opacity = "0.5";
        addToCartBtn.style.cursor = "not-allowed";
      }
    }
  }

  // Initialize upsell variants
  initUpsellVariants();
});
